import { Button } from "@/components/ui/button";

export const AccountTab = () => (
  <div className="space-y-3 sm:space-y-4">
    <div className="rounded-lg sm:rounded-xl border border-border/70 bg-white/80 p-3 sm:p-4 shadow-sm dark:bg-white/5">
      <h4 className="text-xs sm:text-sm font-semibold text-foreground">Upgrade Plan</h4>
      <p className="text-[10px] sm:text-sm text-muted-foreground">Unlock higher limits and premium features. (coming soon)</p>
      <Button className="mt-2 sm:mt-3 h-8 sm:h-9 text-xs sm:text-sm" disabled>
        Upgrade (soon)
      </Button>
    </div>
    <div className="rounded-lg sm:rounded-xl border border-border/70 bg-white/80 p-3 sm:p-4 shadow-sm dark:bg-white/5">
      <h4 className="text-xs sm:text-sm font-semibold text-foreground">Billing Info</h4>
      <p className="text-[10px] sm:text-sm text-muted-foreground">Manage payment methods and invoices. (coming soon)</p>
      <Button className="mt-2 sm:mt-3 h-8 sm:h-9 text-xs sm:text-sm" disabled>
        Edit billing (soon)
      </Button>
    </div>
  </div>
);
